window.fisherAnalytics.cart = {
    version: '1.0.0',
    init: function() {
        if ($.cookie('CART_ID')) {
            this.retrieveAndSetCartDataWithLimit(20);
        } else {
            //Legacy Cart won't have CART_ID cookie set, so use new_cart cookie instead
            if(window.utils.getCookie('new_cart')) {
                localStorage.removeItem('cartDetails');
            }
        }
        // Check if callMinifiedCart session storage item exists
        if (sessionStorage.getItem('callMinifiedCart')) {
            this.callMinifiedCart();
        }
    },
    //dispatches event, saves cart details to local storage, and removes cart data
    cartEmptyEvent: function(){
        if (window.digitalData && window.digitalData.cart) {
            const cart = window.digitalData.cart;
            const payload = {
                cartId: cart.id || "",
                subTotal: cart.subtotal || 0.00,
                products: []
            };
            if (cart.products) {
                payload.products = Object.values(cart.products).map(product => ({
                    name: product.name,
                    sku: product.sku,
                    price: product.price,
                    quantity: product.quantity,
                    variation: product.variation,
                    discount: ""
                }));
            }
            const cartEmptyEvent = new CustomEvent('cartEmpty', {
                detail: {
                    cartPayload: payload
                }
            });
            document.dispatchEvent(cartEmptyEvent);
        }
        delete window.digitalData.cart;
        localStorage.removeItem('cartDetails');
        localStorage.removeItem('cartFindingMethod');
    },
    dispatchEnhancedCartAdd: function(data, requestParams, allLineItems) {
        try {
            if (!data) return;

            //subtotal either coming from overlay style response or non-overlay style response
            const payload = {
                cartId: data.cartId || "",
                subTotal: data.subTotal
                    ? window.fisherAnalytics.utils.cleanAndConvertToFloat(data.subTotal)
                    : data.cartSummary && data.cartSummary.cartSubTotal
                        ? window.fisherAnalytics.utils.cleanAndConvertToFloat(data.cartSummary.cartSubTotal)
                        : 0.00,
                products: []
            };

            // Find the products that were just added to the cart
            if (requestParams.itemList && requestParams.itemList.length > 0) {
                requestParams.itemList.forEach(addedItem => {
                    // Find the corresponding full item details in the cart's line items
                    const foundItem = allLineItems.find(lineItem =>
                        lineItem.partNumber == (addedItem.partNumber + "").replace(/-/g, "")
                    );

                    if (foundItem) {
                        payload.products.push({
                            name: foundItem.productTitleNoGlyphs,
                            sku: foundItem.partNumber,
                            price: foundItem.price,
                            quantity: addedItem.quantity,
                            variation: foundItem.variation,
                            discount: ""
                        });
                    }
                });
            }

            const cartAddEvent = new CustomEvent('cartAdd', {
                detail: {
                    cartPayload: payload
                }
            });
            document.dispatchEvent(cartAddEvent);
        } catch (e) {
            window.fisherAnalytics.utils.log('Error in dispatchEnhancedCartAdd: ' + e);
        }
    },
    dispatchCartRemove: function(data, allLineItems) {
        try {
            if (!data || !allLineItems) return;

            const payload = {
                cartId: data.cartId || "",
                subTotal: data.cartSummary && data.cartSummary.cartSubTotal ? window.fisherAnalytics.utils.cleanAndConvertToFloat(data.cartSummary.cartSubTotal) : 0.00,
                products: []
            };

            // Find the products that were just removed from the cart
            if (window.digitalData && window.digitalData.cart && window.digitalData.cart.products) {
                // Convert allLineItems to a format for easy comparison
                const currentProductKeys = allLineItems.map(item => item.partNumber);

                // Loop through the previous cart products
                Object.entries(window.digitalData.cart.products).forEach(([key, product]) => {
                    // If a product exists in the previous cart but not in the current cart, it was removed
                    if (!currentProductKeys.includes(key)) {
                        payload.products.push({
                            name: product.name,
                            sku: product.sku,
                            price: product.price,
                            quantity: product.quantity,
                            variation: product.variation,
                            discount: ""
                        });
                    }
                });
            }

            const cartRemoveEvent = new CustomEvent('cartRemove', {
                detail: {
                    cartPayload: payload
                }
            });
            document.dispatchEvent(cartRemoveEvent);
        } catch (e) {
            window.fisherAnalytics.utils.log('Error in dispatchCartRemove: ' + e);
        }
    },
    // Process the XHR request
    // This function is called when the XHR request matches the URL pattern of:
    // add to carts, shipping and tax, removal of item from cart, update cart, save for later
    // we are populating the cart object in the data layer
    process: function(body, response, config) {
        if (response.responseText.indexOf(config.responseText) !== -1) {
            var data = JSON.parse(response.responseText);
            if (data && response.status === 200) {
                try {
                    if (data.cartEmpty && !config.saveForLater) { // cart is empty and not a save for later request
                        window.fisherAnalytics.cart.cartEmptyEvent();
                    }else if(!data.wasAdded && body && body.indexOf('Forget+Something') > -1){ //process Errors only forgot something
                        window.fisherAnalytics.cart.processErrors(data);
                    } else { // cart is not empty
                        var cartId = data && data.cartId ? data.cartId : "";
                        var overlayData = data.cartletItemsForAnalytics;
                        var nonOverlayData = data.cartSummary;

                        // Extract cart totals and cost breakdown to set the values in the digital data layer object
                        var totals = window.fisherAnalytics.cart.extractCartTotals(data, overlayData, nonOverlayData);
                        var cartSubTotal = totals.cartSubTotal;
                        var cartTotal = totals.cartTotal;
                        var costBreakdown = totals.costBreakdown;

                        //special flags used for specific scenarios and dispatching events
                        if(config.deleteItem) data.deleteItem = true; // if this is a delete item request, set deleteItem to true
                        if(config.updateItem) data.updateItem = true; // if this is a update item request, set updateItem to true,
                        if(config.moveToCart) data.moveToCart = true; // if this is a moveToCart from save for later request, set moveToCart to true

                        // Extract line items
                        var lineItems = window.fisherAnalytics.cart.populateLineItems(body, data);

                        if (window.digitalData && cartId) {
                            // Set cart and its items
                            window.digitalDataManager.setCart(cartId, cartSubTotal, cartTotal, costBreakdown);
                            window.digitalDataManager.removeCartItems(); //clear products before repopulating
                            lineItems.forEach(function(item) {
                                window.digitalDataManager.setCartItem(item.lineItemID, item.partNumber, item.variation, item.productTitleNoGlyphs, item.price, item.quantity, item.findingMethod);
                            });

                            // Store cart details in local storage
                            window.fisherAnalytics.cart.saveCartDetailsToLocalStorage(cartId, cartSubTotal, cartTotal, costBreakdown, lineItems);
                        }
                    }
                } catch (e) {
                    window.fisherAnalytics.utils.log("issue with new data layer from global ui intercept (EU): " + e);
                }
            }
        } else {
            window.fisherAnalytics.utils.log('no response from XHR request interceptor');
        }
    },
    // Extract cart totals and cost breakdown from response data
    // For the cart add response, there are 2 styles of response data:
    // A response where the cart add happens from the overlay and from nonoverlay
    extractCartTotals: function(data, overlayData, nonOverlayData) {
        var cartSubTotal = 0.00;
        var cartTotal = 0.00;
        var costBreakdown = {
            shippingCharges: {},
            taxes: {}
        };

        if (overlayData) { // overlay data response
            cartSubTotal = data.subTotal ? window.fisherAnalytics.utils.cleanAndConvertToFloat(data.subTotal) : 0.00;
            cartTotal = data.orderTotal ? window.fisherAnalytics.utils.cleanAndConvertToFloat(data.orderTotal) : 0.00;
        }

        if (nonOverlayData) { // non-overlay data response
            cartSubTotal = nonOverlayData.cartSubTotal ? window.fisherAnalytics.utils.cleanAndConvertToFloat(nonOverlayData.cartSubTotal) : 0.00;
            cartTotal = nonOverlayData.cartTotal ? window.fisherAnalytics.utils.cleanAndConvertToFloat(nonOverlayData.cartTotal) : 0.00;
            var shippingAndTax = nonOverlayData.shippingAndTax;
            if (shippingAndTax) {
                if (shippingAndTax.shippingCharges) {
                    shippingAndTax.shippingCharges.forEach(function(shippingCharge) {
                        costBreakdown.shippingCharges[shippingCharge.description] = window.fisherAnalytics.utils.cleanAndConvertToFloat(shippingCharge.chargeAmount);
                    });
                }
                if (shippingAndTax.taxes) {
                    shippingAndTax.taxes.forEach(function(tax) {
                        costBreakdown.taxes[tax.description] = window.fisherAnalytics.utils.cleanAndConvertToFloat(tax.amount);
                    });
                }
            }
        }
        return {
            cartSubTotal: cartSubTotal,
            cartTotal: cartTotal,
            costBreakdown: costBreakdown
        };
    },
    processErrors: function(data) {
        if (data) {
            try {
                if (data.productsNotFoundQuickAdd) { // cart is empty and not a save for later request
                    document.dispatchEvent(new CustomEvent("trackError", {detail: {
                            errorCategory: "Forgot Something",
                            errorDescription: "SKU not valid: " + data.productsNotFoundQuickAdd}
                    }))
                } else if (data.unavailableItems) { // cart
                    // Loop through each unavailable item
                    Object.keys(data.unavailableItems).forEach(function(itemKey) {
                        var item = data.unavailableItems[itemKey];
                        if (item.itemCore && item.itemCore.partNumber) {
                            document.dispatchEvent(new CustomEvent("trackError", {detail: {
                                    errorCategory: "Forgot Something",
                                    errorDescription: "SKU Out of Stock: " + item.itemCore.partNumber}
                            }));
                        }
                    });
                }
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with processErrors on data layer from global ui intercept (US): " + e);
            }
        }
    },
    //this calls the minified cart endpoint to get the cart details
    //for now this is only used upon account login
    callMinifiedCart: function () {
        try {
            // Set session storage before the request
            sessionStorage.setItem("callMinifiedCart", "true");
            const xhr = new XMLHttpRequest();
            xhr.open('GET', '/store1/cart/service/minifiedcart', true);
            xhr.onload = function() {
                if (xhr.status >= 200 && xhr.status < 300) { // Success
                    try {
                        const json = JSON.parse(xhr.responseText);
                        if (typeof json.status !== 'undefined' && json.status === 500) {
                            window.fisherAnalytics.utils.log('minifiedcartdetails call Internal Server Error - from globalUI cart.js');
                        }
                    } catch (e) {
                        window.fisherAnalytics.utils.log('Error parsing JSON response from minifiedcartdetails: ' + e);
                    }
                } else { // Error (e.g., 404, 500 from server, not a network error)
                    window.fisherAnalytics.utils.log('minifiedcartdetails call Error - from globalUI cart.js ' + xhr.status + ' ' + xhr.statusText);
                }
                sessionStorage.removeItem("callMinifiedCart");
            };

            xhr.onerror = function() {// Network error
                window.fisherAnalytics.utils.log('minifiedcartdetails call Error - from globalUI cart.js Network error');
                sessionStorage.removeItem("callMinifiedCart"); // Ensure removal on network error
            };

            xhr.send();
        } catch (e) {
            window.fisherAnalytics.utils.log('minifiedcartdetails call catch error - from globalUI cart.js', e);
            if (sessionStorage.getItem("callMinifiedCart")) {
                sessionStorage.removeItem("callMinifiedCart");
            }
        }
    },
    //Save cart details to localStorage
    //for later retrieval
    saveCartDetailsToLocalStorage: function (cartId, cartSubTotal, cartTotal, costBreakdown, lineItems) {
        var cartDetails = {
            cartId: cartId,
            cartSubTotal: cartSubTotal,
            cartTotal: cartTotal,
            costBreakdown: costBreakdown,
            lineItems: lineItems
        };
        localStorage.setItem('cartDetails', JSON.stringify(cartDetails));
    },
    //Populate line items based on the style of response data
    //(Overlay data, non-overlay data, configurator data)
    populateLineItems: function(body, data) {
        // Extract request data
        const requestParams = window.fisherAnalytics.cart.extractRequestParameters(body);
        const lineItems = [];

        // Process each data type in sequence
        // The following is what will actually set the lineItems array
        // by adding items to it from each data type present in the cart
        window.fisherAnalytics.cart.processOverlayData(data, requestParams, lineItems);
        window.fisherAnalytics.cart.processNonOverlayData(data, requestParams, lineItems);
        window.fisherAnalytics.cart.processConfiguratorData(data, lineItems);

        // The updateItem condition is for a specific add/remove scenario for updating the quantity on the cart page
        if (data.updateItem) {
            window.fisherAnalytics.cart.checkAndDispatchQuantityReduction(lineItems, requestParams);
        } else {
            // Dispatch cart add/remove events
            // The condition here is that we want to skip counting any save for later events because these
            // are manually tracked with the cart ui app and not here in global ui
            if (body && (requestParams.addToCartFrom.indexOf('for Later') === -1 || data.moveToCart)) { // add event (exclude 'for Later' scenarios)
                window.fisherAnalytics.cart.dispatchEnhancedCartAdd(data, requestParams, lineItems);
            } else if (data.deleteItem) { // remove event
                window.fisherAnalytics.cart.dispatchCartRemove(data, lineItems);
            }
        }
        return lineItems;
    },
    // Check for quantity addition/reduction and dispatch cart events if needed
    // This is based on a quantity change happening on the cart page in the EU
    checkAndDispatchQuantityReduction: function(lineItems, requestParams) {
        if (!requestParams.itemList || !window.digitalData || !window.digitalData.cart || !window.digitalData.cart.products) {
            return;
        }

        requestParams.itemList.forEach(requestItem => {
            const partNumber = requestItem.partNumber.replace(/-/g, "");
            const newQuantity = parseInt(requestItem.quantity) || 0;

            // Check if this product exists in the current cart
            const existingProduct = window.digitalData.cart.products[partNumber];
            if (existingProduct && existingProduct.quantity > newQuantity) {
                // Quantity was reduced, dispatch cart remove event with the difference
                const quantityDifference = existingProduct.quantity - newQuantity;
                const payload = {
                    cartId: window.digitalData.cart.id || "",
                    subTotal: window.digitalData.cart.subtotal || 0.00,
                    products: [{
                        name: existingProduct.name,
                        sku: existingProduct.sku,
                        price: existingProduct.price,
                        quantity: quantityDifference,
                        variation: existingProduct.variation,
                        discount: ""
                    }]
                };

                const cartRemoveEvent = new CustomEvent('cartRemove', {
                    detail: {
                        cartPayload: payload
                    }
                });
                document.dispatchEvent(cartRemoveEvent);
            } else if (existingProduct && existingProduct.quantity < newQuantity) {
                // Quantity was increased, dispatch cart add event with the difference
                const quantityDifference = newQuantity - existingProduct.quantity;
                const payload = {
                    cartId: window.digitalData.cart.id || "",
                    subTotal: window.digitalData.cart.subtotal || 0.00,
                    products: [{
                        name: existingProduct.name,
                        sku: existingProduct.sku,
                        price: existingProduct.price,
                        quantity: quantityDifference,
                        variation: existingProduct.variation,
                        discount: ""
                    }]
                };

                const cartAddEvent = new CustomEvent('cartAdd', {
                    detail: {
                        cartPayload: payload
                    }
                });
                document.dispatchEvent(cartAddEvent);
            } else{
                window.fisherAnalytics.cart.checkAndDispatchUomChange(lineItems, requestParams); //uom change and not qty change
            }
        });
    },
    // Check for UOM change and dispatch cart remove/add events
    checkAndDispatchUomChange: function(lineItems, requestParams) {
        if (!requestParams.itemList || !window.digitalData || !window.digitalData.cart || !window.digitalData.cart.products) {
            return;
        }

        requestParams.itemList.forEach(requestItem => {
            const partNumber = requestItem.partNumber.replace(/-/g, "");
            const newUom = requestItem.uom;

            // Search through all products to find matching part number
            Object.entries(window.digitalData.cart.products).forEach(([lineItemKey, existingProduct]) => {
                if (existingProduct.sku === partNumber) {
                    // Find the corresponding item in lineItems for the new UOM and part number
                    const newLineItem = lineItems.find(item =>
                        item.partNumber === partNumber && item.variation === newUom
                    );

                    // Dispatch cart remove event for the existing product
                    const removePayload = {
                        cartId: window.digitalData.cart.id || "",
                        subTotal: window.digitalData.cart.subtotal || 0.00,
                        products: [{
                            name: existingProduct.name,
                            sku: existingProduct.sku,
                            price: existingProduct.price,
                            quantity: existingProduct.quantity,
                            variation: existingProduct.variation,
                            discount: ""
                        }]
                    };

                    const cartRemoveEvent = new CustomEvent('cartRemove', {
                        detail: {
                            cartPayload: removePayload
                        }
                    });
                    document.dispatchEvent(cartRemoveEvent);

                    // Dispatch cart add event with the new UOM and price from lineItems
                    const addPayload = {
                        cartId: window.digitalData.cart.id || "",
                        subTotal: window.digitalData.cart.subtotal || 0.00,
                        products: [{
                            name: existingProduct.name,
                            sku: existingProduct.sku,
                            price: newLineItem ? newLineItem.price : existingProduct.price,
                            quantity: existingProduct.quantity,
                            variation: newUom,
                            discount: ""
                        }]
                    };

                    const cartAddEvent = new CustomEvent('cartAdd', {
                        detail: {
                            cartPayload: addPayload
                        }
                    });
                    document.dispatchEvent(cartAddEvent);
                }
            });
        });
    },
    // Extract parameters from request body
    extractRequestParameters: function(body) {
        const pageName = window.fisherAnalytics.utils.getPageName();
        let addToCartFrom = "";
        let itemList = [];

        if (typeof FormData !== 'undefined' && body instanceof FormData) {
            const params = window.fisherAnalytics.cart.parseQuotesFormAddToCart(body);
            addToCartFrom = params.addToCartFrom || "";
            itemList = params.itemList || [];
        } else if (body) {
            const params = window.fisherAnalytics.utils.parseQueryString(body);
            addToCartFrom = params.addToCartFrom || pageName;
            itemList = params.itemList || [];
        }
        return { addToCartFrom, itemList, pageName };
    },
    // Determine finding method for an item
    getFindingMethod: function(partNumber, variation, requestParams) {
        const { addToCartFrom, itemList, pageName } = requestParams;
        const pageURL = window.fisherAnalytics.utils.getPageURL();

        // Check for part numbers from email links
        if (variation && pageURL.indexOf('emailPartNumbers') !== -1) {
            const emailPartNumbers = this.parseEmailPartNumbers(pageURL);
            if (emailPartNumbers.includes(partNumber)) {
                return "email";
            }
        }

        for (let i = 0; i < itemList.length; i++) {
            if (itemList[i].partNumber == partNumber) {
                if (pageName.indexOf('special-offers-and-programs') !== -1) {
                    return "Special Offers"; // Override for special offers page
                } else {
                    return addToCartFrom;
                }
            } else if (itemList[i].partNumber == partNumber && addToCartFrom === "Forget Something") {
                return "Forget Something"; // Override for Forget Something
            } else if(variation && pageURL.indexOf('emailPartNumbers') != 0){

            }
        }
        return "";
    },
    parseEmailPartNumbers: function(url) {
        // Extract the emailPartNumbers parameter from the URL
        const regex = /[?&]emailPartNumbers=([^&#]*)/;
        const match = url.match(regex);

        if (!match) return [];

        // Decode the URL-encoded string and split by pipe character
        const emailPartNumbersParam = decodeURIComponent(match[1]);
        const partNumbers = emailPartNumbersParam.split('|');

        // Return array of clean part numbers
        return partNumbers.map(partNumber => partNumber.replace(/-/g, "").trim());
    },
    // Process overlay data
    processOverlayData: function(data, requestParams, lineItems) {
        if (!data.cartletItemsForAnalytics) return;

        data.cartletItemsForAnalytics.forEach(item => {
            const partNumber = item.partNumber.replace(/-/g, "");
            const variation = item.uom;

            lineItems.push({
                lineItemID: partNumber,
                partNumber: partNumber,
                productTitleNoGlyphs: item.productTitleNoGlyphs,
                price: window.fisherAnalytics.utils.cleanAndConvertToFloat(item.itemPrice),
                quantity: item.quantity,
                variation: variation,
                findingMethod: window.fisherAnalytics.cart.getFindingMethod(partNumber, variation, requestParams)
            });
        });
    },
    // Process non-overlay data (regular line items / stock items)
    processNonOverlayData: function(data, requestParams, lineItems) {
        if (!data.lineItems && !data.stockItems) return;

        // Map of types to finding methods
        const dataTypes = {
            'lineItems': function(partNumber, variation) {
                return window.fisherAnalytics.cart.getFindingMethod(partNumber, variation, requestParams);
            },
            'stockItems': function() {
                return 'Stock Item';
            }
        };

        // Process each data type in a single loop
        Object.keys(dataTypes).forEach(dataType => {
            if (!data[dataType]) return;

            Object.keys(data[dataType]).forEach(key => {
                const item = data[dataType][key];
                const partNumber = item.itemCore.partNumber.replace(/-/g, "");
                const productTitleNoGlyphs = item.itemCore.productTitleNoGlyphs;
                let price = "";
                let quantity = 0;
                let variation = "";

                item.priceUoms.forEach(priceUom => {
                    if (priceUom.selected) {
                        price = window.fisherAnalytics.utils.cleanAndConvertToFloat(priceUom.itemPrice);
                        quantity = priceUom.quantity;
                        variation = priceUom.uom;
                    }
                });

                lineItems.push({
                    lineItemID: partNumber,
                    partNumber: partNumber,
                    productTitleNoGlyphs: productTitleNoGlyphs,
                    price: price,
                    quantity: quantity,
                    variation: variation,
                    findingMethod: dataTypes[dataType](partNumber, variation)
                });
            });
        });
    },
    // Process configurator cart data
    processConfiguratorData: function(data, lineItems) {
        if (!data.configItems) return;

        // Map of configurator types to finding methods
        const configuratorTypes = {
            'rndItem': 'RNDSystem',
            'lsgItem': 'LSG',
            'emoleculesItem': 'Emolecules'
        };

        // Process each configurator type
        Object.keys(configuratorTypes).forEach(configType => {
            if (!data.configItems[configType] || !data.configItems[configType].lineItems) return;

            const findingMethod = configuratorTypes[configType];
            const items = data.configItems[configType].lineItems;

            Object.keys(items).forEach(key => {
                const lineItem = items[key];
                const partNumber = lineItem.itemCore.partNumber.replace(/-/g, "");
                const productTitleNoGlyphs = lineItem.itemCore.productTitleNoGlyphs;
                let price = "";
                let quantity = 0;
                let variation = "";

                lineItem.priceUoms.forEach(priceUom => {
                    if (priceUom.selected) {
                        price = window.fisherAnalytics.utils.cleanAndConvertToFloat(priceUom.itemPrice);
                        quantity = priceUom.quantity;
                        variation = priceUom.uom;
                    }
                });

                lineItems.push({
                    lineItemID: partNumber,
                    partNumber: partNumber,
                    productTitleNoGlyphs: productTitleNoGlyphs,
                    price: price,
                    quantity: quantity,
                    variation: variation,
                    findingMethod: findingMethod
                });
            });
        });
    },
    // Retrieves the cart details from localStorage and sets the data layer
    retrieveAndSetCartData: function() {
        try{
            const cartDetailsJSON = localStorage.getItem('cartDetails');
            if (cartDetailsJSON) {
                const cartDetails = JSON.parse(cartDetailsJSON);

                // Destructure the necessary values from cartDetails
                const { cartId, cartSubTotal, cartTotal, costBreakdown, lineItems } = cartDetails;

                // Call the setCart function with the values from cartDetails
                window.digitalDataManager.setCart(cartId, cartSubTotal, cartTotal, costBreakdown);

                // Iterate through each line item and call setCartItem
                lineItems.forEach(item => {
                    const { findingMethod, lineItemID, partNumber, productTitleNoGlyphs, price, quantity, variation } = item;
                    window.digitalDataManager.setCartItem(lineItemID, partNumber, variation, productTitleNoGlyphs, price, quantity, findingMethod);
                });
            }
        } catch (e){
            window.fisherAnalytics.utils.log("issue with retrieving cart data from localStorage: " + e);
        }
    },
    parseQuotesFormAddToCart: function(quotesForm) {
        let params = {
            addToCartFrom: 'QuotesAddItemsToCart',
            itemList: []
        };
        try{
            quotesForm.forEach((value, key) => {
                // Determine the index and actual key
                const match = key.match(/^(\d+)(.*)$/);
                if (match) {
                    const index = parseInt(match[1], 10);
                    const actualKey = match[2];
                    // Ensure the item at the index exists
                    if (!params.itemList[index]) {
                        params.itemList[index] = {};
                    }
                    // Map the keys to the desired format
                    switch (actualKey) {
                        case '_partNumber':
                            params.itemList[index].partNumber = value;
                            break;
                        case 'units':
                            params.itemList[index].uom = value;
                            break;
                        case '_desired_quantity':
                            params.itemList[index].quantity = value;
                            break;
                        default:
                            params.itemList[index][actualKey] = value;
                    }
                } else {
                    // Handle non-indexed keys
                    params[key] = value;
                }
            });
        }catch (e) {
            window.fisherAnalytics.utils.log("issue with parsing quotes form data: " + e);
        }
        return params;
    },
    // Retrieves the cart data from localStorage and sets the data layer with a limit on attempts
    // to check for the presence of digitalData
    retrieveAndSetCartDataWithLimit: function(attempts) {
        var attemptCount = 0;
        var interval = setInterval(function() {
            if (window.digitalData) {
                clearInterval(interval);
                window.fisherAnalytics.cart.retrieveAndSetCartData();
            } else if (attemptCount >= attempts) {
                clearInterval(interval);
            } else {
                attemptCount++;
            }
        }, 100);
    }
};

// Initialize the cart module
window.fisherAnalytics.cart.init();
